export const langOptions = {
    'en' : {id: 1, code: 'en', label: 'English'},
    'he': {id: 5, code: 'he', label: 'עברית'},
}